import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="py-16 md:py-20 bg-gray-50">
      <div className="w-full px-4 sm:px-6 lg:px-10">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">{t('categories.title')}</h2>
          <p className="text-gray-600 text-sm md:text-base max-w-xl mx-auto">Browse our organized AllChinaBuy spreadsheet categories for quick access to product finds</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col overflow-hidden rounded-xl bg-white border border-gray-100 hover:border-emerald-200 hover:shadow-md transition-all duration-200"
            >
              <div className="aspect-[4/3] overflow-hidden bg-gray-100">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex items-center gap-2 px-3 md:px-4 py-3">
                <div className="w-7 h-7 rounded-lg bg-emerald-50 flex items-center justify-center shrink-0">
                  <i className={`${cat.icon} text-emerald-600 text-sm`}></i>
                </div>
                <span className="text-xs md:text-sm font-semibold text-gray-800 group-hover:text-emerald-700 transition-colors leading-tight">{cat.name}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}